import type { RunItemVerdict } from "@nova-ai/shared"

import { StatusBadge, type BadgeTone } from "../ui/status-badge"

// The single owner of the verdict → badge rendering. Both the run storefront and
// the per-marketplace current-state page render a config's `RunItemVerdict` this
// way, so the two views can never drift on tone, label, or the pending fallback.
const VERDICT_BADGE: Record<RunItemVerdict, { label: string; tone: BadgeTone; title: string }> = {
  ok: { label: "OK", tone: "success", title: "Validated OK" },
  nok: { label: "NOK", tone: "destructive", title: "Validated NOK" },
}

/** A config's current verdict as a `StatusBadge`. Null (no covering run yet)
 *  renders the muted `pending` fallback. */
export function VerdictBadge({ verdict }: { verdict: RunItemVerdict | null }) {
  if (!verdict) {
    return (
      <StatusBadge size="sm" tone="muted" title="Not classified yet">
        pending
      </StatusBadge>
    )
  }

  const badge = VERDICT_BADGE[verdict]
  return (
    <StatusBadge size="sm" tone={badge.tone} title={badge.title}>
      {badge.label}
    </StatusBadge>
  )
}
